import { EapSettingsTtlsFormValidationModel } from './eap-settings-form-ttls-protocol.model';

export const initialEapTtlsFormValidation: EapSettingsTtlsFormValidationModel = {
    username: { state: 'valid' },
    password: { state: 'valid' },
    confirmPassword: { state: 'valid' },
};
